import { render } from "./MediaInputManager.vue?vue&type=template&id=970dedb0"
import script from "./MediaInputManager.vue?vue&type=script&lang=js"
export * from "./MediaInputManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QFile from 'quasar/src/components/file/QFile.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QFile});
